import React, { useEffect } from 'react';
import SignalsPresentational from './SignalsPresentational';
import './MySignals.scss';
import { useAuth } from '../../../commons/Auth';

const SignalsAdminSpecialJobs = ({
  profile,
  query,
  total,
  signals,
  signalTypes,
  onFilter,
  onUpdateSignal,
  searchSignalmens,
  searchAdmins,
  handleFileListView,
  deleteFileConfirm,
}) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();

  return (
    <SignalsPresentational
      data={signals}
      signalTypes={signalTypes}
      profile={profile}
      newIsAdmin={newIsAdmin}
      query={query}
      total={total}
      onFilter={onFilter}
      onUpdateSignal={onUpdateSignal}
      searchSignalmens={searchSignalmens}
      searchAdmins={searchAdmins}
      handleFileListView={handleFileListView}
      deleteFileConfirm={deleteFileConfirm}
    />
  );
};

export default SignalsAdminSpecialJobs;
